import React from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

const ButtonS = styled(Button)`
  margin: ${({ margin }) => margin || '0'};
`;

export function AntButton(props) {
  return <ButtonS {...props} />;
}

export function SubmitButton(props) {
  return <AntButton block margin="20px 0 0 0" type="primary" {...props} />;
}
